import { fromEvent, map, Subject, takeUntil } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { LIBRARY_CONFIG, UserState } from '../../shared';
import { EventSourcePolyfill } from 'event-source-polyfill';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
export class SseStreamService {
  store;
  libraryConfig;
  unSubscribe$ = new Subject();
  eventSource;
  timeOutMinutes = 100; // The Stream is open for that Time and will reconnect after that time.
  eventSourceStream$;
  constructor(store, libraryConfig) {
    this.store = store;
    this.libraryConfig = libraryConfig;
  }
  connect() {
    if (this.eventSource && this.eventSourceStream$) {
      console.warn('SSE-Stream is already connected!');
      return;
    }
    const url = this.libraryConfig?.sseStreamBaseUrl ?? this.libraryConfig?.baseUrl;
    if (!url) {
      console.warn('SSE-Hub: baseUrl is not provided, stream connection will not work! please provide a valid sseStreamBaseUrl or baseUrl to your libConfig!');
      return;
    }
    const token = this.store.selectSnapshot(UserState.token);
    const sseUrl = `${url}sse-hub/v1/event-stream`;
    this.eventSource = new EventSourcePolyfill(sseUrl, {
      headers: {
        Authorization: 'Bearer ' + token
      },
      heartbeatTimeout: 60000 * this.timeOutMinutes
    });
    fromEvent(this.eventSource, 'error').pipe(takeUntil(this.unSubscribe$)).subscribe(event => {
      console.error('SSE Error:', event);
    });
    this.eventSourceStream$ = fromEvent(this.eventSource, 'message').pipe(takeUntil(this.unSubscribe$), map(event => JSON.parse(event.data)));
  }
  get sseEventStream() {
    if (!this.eventSourceStream$) {
      throw new Error('No EventSourceStream available. Call connect() first.');
    }
    return this.eventSourceStream$;
  }
  disconnect() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
    this.eventSource?.close();
  }
  static ɵfac = function SseStreamService_Factory(t) {
    return new (t || SseStreamService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(LIBRARY_CONFIG));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SseStreamService,
    factory: SseStreamService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SseStreamService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.Store
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [LIBRARY_CONFIG]
    }]
  }], null);
})();
